import { trackSelfDescribingEvent } from "@snowplow/browser-tracker";

import { RecommenderImpressionContext } from "../types";

export function emitRecommenderImpression({
  source_type = null,
  from_product_ids,
  from_product_offer_id,
  from_product_displayed_price,
  recommended_product_count,
}: RecommenderImpressionContext["options"]) {
  trackSelfDescribingEvent({
    event: {
      schema: "iglu:au.com.catch/recommender_impression/jsonschema/1-0-2",
      data: {
        source_type,
        from_product_ids,
        from_product_offer_id,
        from_product_displayed_price,
        recommended_product_count,
      },
    },
  });
}
